"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SummaryCounter = exports.CountType = void 0;
var CountType;
(function (CountType) {
    CountType[CountType["ORIGINAL_LINKS_POSSIBLE_TO_BE_UPDATED"] = 0] = "ORIGINAL_LINKS_POSSIBLE_TO_BE_UPDATED";
    CountType[CountType["ORIGINAL_LINKS_UPDATED"] = 1] = "ORIGINAL_LINKS_UPDATED";
    CountType[CountType["ORIGINAL_LINKS_POSSIBLE_TO_BE_REPLACED"] = 2] = "ORIGINAL_LINKS_POSSIBLE_TO_BE_REPLACED";
    CountType[CountType["ORIGINAL_LINKS_REPLACED"] = 3] = "ORIGINAL_LINKS_REPLACED";
    CountType[CountType["POSSIBLE_ADDITIONAL_ALTERNATIVES"] = 4] = "POSSIBLE_ADDITIONAL_ALTERNATIVES";
    CountType[CountType["DISPLAYED_ADDITIONAL_ALTERNATIVES"] = 5] = "DISPLAYED_ADDITIONAL_ALTERNATIVES";
})(CountType || (exports.CountType = CountType = {}));
class SummaryCounter {
    #countsPerCard = [];
    increment(cardIndex, countType, amount = 1) {
        if (!this.#countsExistForCard(cardIndex)) {
            this.#countsPerCard[cardIndex] = new Map();
        }
        const count = this.#countsPerCard[cardIndex].get(countType) || 0;
        this.#countsPerCard[cardIndex].set(countType, count + amount);
    }
    getCountByIndexAndType(cardIndex, countType) {
        if (!this.#countsExistForCard(cardIndex)) {
            return 0;
        }
        return this.#countsPerCard[cardIndex].get(countType) || 0;
    }
    #countsExistForCard(cardIndex) {
        return !!this.#countsPerCard[cardIndex];
    }
}
exports.SummaryCounter = SummaryCounter;
